module.exports = __webpack_public_path__ + "static/media/astronauta_4.0c642dac.svg";